module.exports = "./img/90e42bded5e7fe387cb9870a7842d46b.jpg";